import React from 'react';
import { InstagramIcon, BrainIcon, MailIcon } from 'lucide-react';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function Footer() {
  return <footer className="bg-cream py-12 border-t border-rose/20 relative overflow-hidden" data-id="element-67">
      <div className="absolute top-1/2 left-10 opacity-20" data-id="element-68">
        <SparkleDecoration size={24} color="#E8735A" type="star" data-id="element-69" />
      </div>
      <div className="absolute top-1/3 right-10 opacity-20" data-id="element-70">
        <SparkleDecoration size={30} color="#E8735A" data-id="element-71" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-72">
        <div className="flex justify-center items-center gap-2 mb-6" data-id="element-73">
          <span className="text-coral font-serif text-2xl font-bold flex items-center gap-1" data-id="element-74">
            <SparkleDecoration size={16} color="#E8735A" type="star" data-id="element-75" />∞
            InfinitaMenteDigital
            <BrainIcon size={22} className="text-coral" data-id="element-76" />
          </span>
        </div>

        <p className="text-charcoal/60 text-sm mb-6" data-id="element-77">
          © 2026 InfinitaMenteDigital. Todos los derechos reservados.
        </p>

        <div className="flex flex-col items-center gap-3" data-id="element-78">
          <p className="text-sm font-bold text-charcoal/70" data-id="element-79">Encontranos en:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-charcoal/70" data-id="element-80">
            <a href="https://instagram.com/infinitamente.digital" target="_blank" rel="noopener noreferrer" className="hover:text-coral transition-colors flex items-center gap-1.5" data-id="element-81">
              <InstagramIcon size={16} data-id="element-82" />{' '}
              <span className="font-medium" data-id="element-83">@infinitamente.digital</span>
            </a>
            <span className="text-rose/40" data-id="element-84">|</span>
            <a href="mailto:soporte@infinita-mente.online" className="hover:text-coral transition-colors flex items-center gap-1.5" data-id="element-85">
              <MailIcon size={16} data-id="element-86" />{' '}
              <span className="font-medium" data-id="element-87">soporte@infinita-mente.online</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}